import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { playClick } from '../utils/SoundManager';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * أزرار "من شاهد ملفي" + "من أعجب بي" مع شارات الإشعارات
 * تُعرض في الهيدر العلوي بشكل بارز
 */
function HeaderNotifications() {
  const navigate = useNavigate();
  const [badges, setBadges] = useState({ new_views: 0, new_likes: 0 });

  const fetchBadges = useCallback(async () => {
    try {
      const uid = localStorage.getItem('userId');
      const headers = uid ? { 'X-User-Id': uid } : {};
      const r = await axios.get(`${BACKEND_URL}/api/stats/badges`, {
        withCredentials: true, headers
      });
      setBadges(r.data || { new_views: 0, new_likes: 0 });
    } catch (e) {
      // الزائر غير مسجل دخول - لا نُظهر شيئاً
      setBadges({ new_views: 0, new_likes: 0 });
    }
  }, []);

  useEffect(() => {
    fetchBadges();
    // إعادة الفحص كل 30 ثانية لتحديث العدّاد بشكل live
    const interval = setInterval(fetchBadges, 30000);
    return () => clearInterval(interval);
  }, [fetchBadges]);

  const openSection = (type) => {
    playClick();
    // تصفير العدّاد فوراً للتغذية الراجعة المباشرة
    if (type === 'views') setBadges(prev => ({ ...prev, new_views: 0 }));
    if (type === 'likes') setBadges(prev => ({ ...prev, new_likes: 0 }));
    
    // إخبار السيرفر
    const uid = localStorage.getItem('userId');
    const headers = uid ? { 'X-User-Id': uid } : {};
    axios.post(`${BACKEND_URL}/api/stats/mark-seen`, { type }, {
      withCredentials: true, headers
    }).catch(() => {});
    
    // الانتقال لصفحة الإحصائيات مع تمرير تبويب محدد
    navigate(`/stats?tab=${type}`);
  };

  const Btn = ({ icon, label, count, onClick, color, testid }) => (
    <button
      data-testid={testid}
      onClick={onClick}
      title={label}
      style={{
        position: 'relative',
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        padding: '6px',
        borderRadius: '50%',
        width: '42px',
        height: '42px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '20px',
        transition: 'transform 0.2s ease, background 0.2s ease'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = 'var(--light-bg)';
        e.currentTarget.style.transform = 'scale(1.1)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = 'transparent';
        e.currentTarget.style.transform = 'scale(1)';
      }}
    >
      <span>{icon}</span>
      {count > 0 && (
        <span
          data-testid={`${testid}-badge`}
          style={{
            position: 'absolute',
            top: '0px',
            left: '-2px',
            background: color,
            color: 'white',
            fontSize: '10px',
            fontWeight: '800',
            minWidth: '18px',
            height: '18px',
            borderRadius: '9px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '0 5px',
            boxShadow: '0 2px 6px rgba(0, 0, 0, 0.25)',
            border: '2px solid var(--card-bg)',
            lineHeight: 1,
          }}
        >
          {count > 99 ? '99+' : count}
        </span>
      )}
    </button>
  );

  return (
    <div
      data-testid="header-notifications"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
      }}
    >
      <Btn
        icon="👁️"
        label="من شاهد ملفي"
        count={badges.new_views}
        onClick={() => openSection('views')}
        color="#1DA1F2"
        testid="header-views-btn"
      />
      <Btn
        icon="❤️"
        label="من أعجب بي"
        count={badges.new_likes}
        onClick={() => openSection('likes')}
        color="#e91e63"
        testid="header-likes-btn"
      />
    </div>
  );
}

export default HeaderNotifications;
